<template>

    <div class="card mb-4 border-warning" v-if="updatedCartItems.length > 0">
        <div class="card-header bg-warning">
            <i class="bi bi-exclamation-circle"></i>
            {{ __('Bitte beachten Sie, dass sich die Preise bei folgenden Produkten geändert haben') }}
        </div>
        <div class="card-body">
            <div v-for="updatedCartItem in updatedCartItems">
                <div class="row">
                    <div class="col-2">
                        <div class="small text-uppercase text-secondary">
                            {{ __('Lieferanten-Artikelnr.') }}
                        </div>
                        <div class="">
                            {{ updatedCartItem.supplier_pid }}
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="small text-uppercase text-secondary">
                            {{ __('Produkt') }}
                        </div>
                        <div>
                            {{ updatedCartItem.product_name }}
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="small text-uppercase text-secondary">
                            {{ __('Bisheriger Preis') }}
                        </div>
                        <div class="fw-bold text-danger">
                            {{ updatedCartItem.previous_price | localizeAmount }}
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="small text-uppercase text-secondary">
                            {{ __('Neuer Preis') }}
                        </div>
                        <div class="fw-bold text-success">
                            {{ updatedCartItem.price | localizeAmount }}
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: [
            'updatedCartItems',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>